import React from 'react'
import ViewAssetTypeCode from '../../components/assettypecodecomponents/ViewAssetTypeCode'

function AssetTypeCodeView({ renderPageContent }) {
    return (
        <>

            {/*Dynamic content goes here */}
            <ViewAssetTypeCode renderPageContent={renderPageContent} />


        </>
    )
}

export default AssetTypeCodeView;